class Coordinationindexes extends Array {}

const coordinationindexes_api_adapter = coordinationindexes => coordinationindexes;

const coordinationindexes_list_api_adapter = coordinationindexes =>
    coordinationindexes.map(coordinationindexes_api_adapter);

const createCoordinationindexesList = (data = []) => {
    const coordinationindexes = Coordinationindexes.from(data, coordinationindexes =>
        createCoordinationindexes(coordinationindexes)
    );
    return coordinationindexes;
};

const coordinationindexes_view_adapter = coordinationindexes => {
    return coordinationindexes;
};

const createCoordinationindexes = ({
    ci = null,
    ci_com = null,
    ci_com_txt = null,
    ci_hor = null,
    ci_hor_txt = null,
    ci_res = null,
    ci_res_txt = null,
    ci_spa = null,
    ci_spa_txt = null,
    ci_ver = null,
    ci_ver_txt = null,
    ci_txt = null,
    country = null,
    geom = null,
    id = null,
} = {}) => {
    const publicApi = {
        ci,
        ci_com,
        ci_com_txt,
        ci_hor,
        ci_hor_txt,
        ci_res,
        ci_res_txt,
        ci_spa,
        ci_spa_txt,
        ci_ver,
        ci_ver_txt,
        ci_txt,
        country,
        geom,
        id,
    };

    return Object.freeze(publicApi);
};

export {
    createCoordinationindexes,
    createCoordinationindexesList,
    coordinationindexes_api_adapter,
    coordinationindexes_list_api_adapter,
    coordinationindexes_view_adapter,
};
